/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOpenTimecardAndBreakForEmployeeRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetOpenTimecardAndBreakForEmployeeResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getOpenTimecardAndBreakForEmployee = (request: GetOpenTimecardAndBreakForEmployeeRequest, options?: CashRequestOptions) => post<GetOpenTimecardAndBreakForEmployeeRequest, GetOpenTimecardAndBreakForEmployeeResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetOpenTimecardAndBreakForEmployee", request, {...options, rejectOnError: true })